module.exports = __webpack_public_path__ + "img/123.4.f56fb682.png";